<template>
  <WdsButtonGhost
    secondary
    :href="hireUrl"
    :disabled="!hireUrl"
    :title="column?.job.name ?? ''"
    class="hire-title-navigation-column"
  >
    <span class="hire-title-navigation-column__name">
      {{ column?.job.name ?? '' }}
    </span>
  </WdsButtonGhost>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsButtonGhost } from '@worksome/wds-components'
import { graphql, FragmentType, useFragment } from '@/gql'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const frag = graphql(`
  fragment HireTitleNavigationColumn on Hire {
    id
    job {
      id
      name
    }
    supplierHire {
      id
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof frag>
}>()

const column = computed(() => {
  if (!props.row) return null

  return useFragment(frag, props.row)
})

const hireUrl = computed(() => {
  const targetId = column.value?.supplierHire?.id ?? column.value?.id
  if (!targetId) return undefined
  return laravelNamedRoute(namedRoutes.hires.hire.view, { hire: targetId, tab: 'overview' })
})
</script>

<style lang="scss">
.hire-title-navigation-column {
  text-align: left;

  &__name {
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
